import { GET_BENEFIT_GROUPS, GET_BENEFIT_GROUPS_SUCCESS, GET_BENEFIT_GROUPS_ERROR, BENEFIT_PACK_LIST_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const BenefitGroups = (state = initialState, action) => {
  switch (action.type) {
    case GET_BENEFIT_GROUPS:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_BENEFIT_GROUPS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_BENEFIT_GROUPS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case BENEFIT_PACK_LIST_EMPTY:
      state = {
        data: null,
        message: null,
        loading: false,
        success: false,
        error: false,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default BenefitGroups;
